module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/cta1_dochimom2-3b94a9ed7fa2c626140e7a3d2fb9db22.png";